<template>
  <v-flex xs12 sm8 md4 lg4>
    <slot name="content"></slot>
  </v-flex>
</template>

<script>

export default {
  name: 'Message',
  data () {
    return {}
  }
}
</script>
